import { HistoricalPercentageChangeDataItem } from 'widgets/historicalPercentageChange/data/historicalPercentageChangeDataItem.ts';
import {
    NumberFormat,
    timeFormatConstants,
} from '@instinet-analytics/core-lib';
import omitUndefined from 'utils/omitUndefined.ts';
import { DateTime } from 'luxon';

const { date } = timeFormatConstants;

export type FormattedDataItem = {
    date: string;
    price: string;
    averageVolume: string;
    volume: string;
    percent: string;
    percentPositive: boolean;
};

export function toFormattedDataItem(
    averageVolume: number | undefined,
    item: HistoricalPercentageChangeDataItem | undefined,
    numberFormat: NumberFormat
): FormattedDataItem | undefined {
    if (!item) {
        return undefined;
    }
    const percentPositive = !!(item.percentChange && item.percentChange > 0);
    const sign = percentPositive ? '+' : '';
    return omitUndefined({
        date: DateTime.fromMillis(item.date).toFormat(date),
        price: item.price !== undefined ? numberFormat.raw(item.price) : '',
        percent:
            item.percentChange !== undefined
                ? sign + numberFormat.n2(item.percentChange)
                : '',
        percentPositive,
        averageVolume:
            averageVolume !== undefined ? numberFormat.n0(averageVolume) : '',
        volume: item.volume !== undefined ? numberFormat.n0(item.volume) : '',
    });
}
